import React from 'react';
import PropTypes from 'prop-types';
import Registry from 'registry';
import {t} from "l10n";

import paths from "../../paths";
import ListItem from "../materialList/listItem";
import ResponsiveList from "./ResponsiveList";
import {Link} from "../ReactRouterDomLocalized";

import 'sass/list/list.scss';

const LastItemsList = ({ items, type }) => {
    let title, link, bobstore, grayBg;
    let BOBSTORE_URL = Registry.get('BOBSTORE_URL');
    let target = null;

    if (type === 'wall') {
        link = {
            url: paths.wall.path,
            title: 'See all posts of the wall'
        };
        title = 'Last post of the Wall';
    }

    if (type === 'wardrobe') {
        link = {
            url: paths.wardrobe.path,
            title: 'See all posts of the wall'
        };
        title = 'Bobstore wardrobe';
        grayBg = true;
    }

    if (type === 'video') {
        link = {
            url: paths.amateurFilms.toPath(),
            title: 'See all amateur videos'
        };
        title = 'The latest amateur videos';
        grayBg = true;
    }

    if (type === 'real_gift') {
        link = {
            url: paths.wishlists.path,
            title: 'All wishlists'
        };
        title = 'Last received real gifts';
        grayBg = false;
    }

    if (type === 'virtual_gift') {
        title = 'Last received virtual gifts';
    }

    if (type === 'bobstore') {
        title = 'Last submissions on';
        target = "_blank";
        bobstore = true;
    }

    return (
        <article className={`last-items-list${grayBg ? ' gray-bg' : ''}`}>
            <div className="content">
                <p className="name">{t(title)} {bobstore && <a href={BOBSTORE_URL} target="_blank">Bobstore</a>}</p>
                    <ResponsiveList className={"list ui-responsive-grid"} list={items}>
                        {(item, index) => {
                            return (
                                <ListItem material={item} type={type} key={index} target={target} order="" />
                            )
                        }}
                    </ResponsiveList>
            </div>
            {link && <Link to={link.url} className="link">{t(link.title)}</Link>}
            {bobstore && <a href={BOBSTORE_URL} target="_blank" className="link">{t('Open Bobstore')}</a>}
        </article>

    )
};

LastItemsList.propTypes = {
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    type: PropTypes.string.isRequired,
};

export default LastItemsList;



// WEBPACK FOOTER //
// ./src/components/index/List.js